"use strict";

exports.__esModule = true;
exports["default"] = getTabbableElements;

function getTabbableElements(element) {
  if (element && element.querySelectorAll) {
    var elementNodeList = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.slice.call(elementNodeList);
  }

  return [];
}